import { BorderBox } from "@/components/atoms/BorderBox";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { SelectCrmSystemSanitizedCombobox } from "@/features/crm_system/components/molecules/SelectCrmSystemSanitizedCombobox";
import { AddCrmModalStepProps } from "@/features/crm_system/lib/_core/crmSystem";
import { useAddCrmModalSimplifiedContext } from "../../../context/AddCrmModalSimplifiedContext";
import { useEffect, useMemo } from "react";

export function CrmNameAndSystemStepTitle() {
    return (
        <>Select CRM Type</>
    )
}

export function CrmNameAndSystemStep({ form }: Readonly<AddCrmModalStepProps>) {
    const pickedCrmSystem = form.watch('crm_system');
    const nameFieldValue = form.watch('name');
    const nameFieldState = form.getFieldState('name');
    const { setIsCurrentStepValid } = useAddCrmModalSimplifiedContext()
    useEffect(()=>{
        form.trigger('name')
    },[nameFieldValue])
    const isStepValid = useMemo(()=>!!pickedCrmSystem && nameFieldState.invalid === false, [pickedCrmSystem, nameFieldState.invalid]);
    setIsCurrentStepValid(isStepValid);
    return (
        <div className="flex flex-col gap-3">
            {pickedCrmSystem === 'airtable' && (
                <BorderBox variant='info' size='sm'>
                    Airtable Parameters are defined based on a particular workspace. A workspace has a unique Personal Access Token and Base Id.
                </BorderBox>
            )}
            <div className="flex flex-col gap-3">
                <FormField
                    control={form.control}
                    name="crm_system"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>CRM System</FormLabel>
                            <FormControl>
                                <SelectCrmSystemSanitizedCombobox
                                    selectedValue={field.value}
                                    setSelectedValue={field.onChange}
                                    mode='single'
                                    inDialog
                                />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="name"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>CRM Name</FormLabel>
                            <FormControl>
                                <Input value={field.value} onChange={field.onChange} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
            </div>
        </div>
    )
}